import React from 'react'
import "./ProjectTasks.css"

export default function SkeletonUI() {
  return (  
  <div className="skeleton-wrapper"> 
        <div className='skeleton skeleton-text long' style={{width: '100%'}}>
         <div className="skeleton-button" 
         style={{background:"lightgray",border:"1px solid white",position:"absolute",left:".3em",top:'-.8rem',width:"7rem",height:"2rem"}}/>  
         </div>       
        <div className='skeleton skeleton-text long' style={{width: '100%'}}>
         <div className="skeleton-button" 
         style={{background:"lightgray",border:"1px solid white",position:"absolute",left:".3em",top:'-.8rem',width:"7rem",height:"2rem"}}/>  
         </div>      
        <div className='skeleton skeleton-text long' style={{width: '100%'}}>
         <div className="skeleton-button" 
         style={{background:"lightgray",border:"1px solid white",position:"absolute",left:".3em",top:'-.8rem',width:"7rem",height:"2rem"}}/>  
         </div>     
        <div className='skeleton skeleton-text long' style={{width: '100%'}}>
         <div className="skeleton-button" 
         style={{background:"lightgray",border:"1px solid white",position:"absolute",left:".3em",top:'-.8rem',width:"7rem",height:"2rem"}}/>  
         </div>     
        <div className='skeleton skeleton-text long' style={{width: '100%'}}>
         <div className="skeleton-button" 
         style={{background:"lightgray",border:"1px solid white",position:"absolute",left:".3em",top:'-.8rem',width:"7rem",height:"2rem"}}/>  
         </div>      
        <div className='skeleton skeleton-text long' style={{width: '100%'}}>
         <div className="skeleton-button" 
         style={{background:"lightgray",border:"1px solid white",position:"absolute",left:".3em",top:'-.8rem',width:"7rem",height:"2rem"}}/>  
         </div>     
        <div className='skeleton skeleton-text long' style={{width: '100%'}}>
         <div className="skeleton-button" 
         style={{background:"lightgray",border:"1px solid white",position:"absolute",left:".3em",top:'-.8rem',width:"7rem",height:"2rem"}}/>  
         </div>    
        <div className='skeleton skeleton-text long' style={{width: '100%'}}>
         <div className="skeleton-button" 
         style={{background:"lightgray",border:"1px solid white",position:"absolute",left:".3em",top:'-.8rem',width:"7rem",height:"2rem"}}/>  
         </div>     
        <div className='skeleton skeleton-text long' style={{width: '100%'}}>
         <div className="skeleton-button" 
         style={{background:"lightgray",border:"1px solid white",position:"absolute",left:".3em",top:'-.8rem',width:"7rem",height:"2rem"}}/>  
         </div>      
        <div className='skeleton skeleton-text long' style={{width: '100%'}}>
         <div className="skeleton-button" 
         style={{background:"lightgray",border:"1px solid white",position:"absolute",left:".3em",top:'-.8rem',width:"7rem",height:"2rem"}}/>  
         </div>   
        <div className='skeleton skeleton-text long' style={{width: '100%'}}>
         <div className="skeleton-button" 
         style={{background:"lightgray",border:"1px solid white",position:"absolute",left:".3em",top:'-.8rem',width:"7rem",height:"2rem"}}/>  
         </div>   
        <div className='skeleton skeleton-text long' style={{width: '100%'}}>
         <div className="skeleton-button" 
         style={{background:"lightgray",border:"1px solid white",position:"absolute",left:".3em",top:'-.8rem',width:"7rem",height:"2rem"}}/>  
         </div>   
        <div className='skeleton skeleton-text long' style={{width: '100%'}}>
         <div className="skeleton-button" 
         style={{background:"lightgray",border:"1px solid white",position:"absolute",left:".3em",top:'-.8rem',width:"7rem",height:"2rem"}}/>  
         </div>   
    </div> 
  )
}
